// Other non generated types
import { Condition, GenericDsl, HttpGenericDsl, MessageType, MsgGenericDsl } from 'types/rest/dslTypes';
import { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { FilterOperator } from '../../views/AssetCatalog/Transactions/TransactionEditor/ProcessingActions/stateChange/SelectOperatorDropdown';
import { NodeList } from '../../store/marFiles/marFilesTypes';
import { AssetAssignment } from './mockServiceTypes';
import { PairSetItem } from '../../components/pairSet/PairSetList';
import { HttpRequestDefinition } from '../../components/sandBox/SandBox.types';

export interface Service {
  workspaceId: number;
  id?: number;
  name: string;
  description?: string;
}

export interface Tag {
  id: number;
  name: string;
}

export type TransactionType = 'HTTP' | 'MESSAGING';

export interface Transaction {
  id?: number;
  type: TransactionType;
  name: string;
  dsl: GenericDsl;
  description: string;
  tags?: string[];
  serviceName?: string; // added to enable update of transaction
  serviceId?: number;
  priority: number;
  created?: number;
  createdBy?: string;
  createdDate?: string;
  updated?: number;
  updatedBy?: string;
  updatedDate?: string;
  sampleBody?: SampleBody | string;
  assets?: AssetAssignment[];
  configKeyAssets?: AssetAssignment[];
  sqlHint?: string;
}

export interface HttpTransaction extends Transaction {
  dsl: HttpGenericDsl;
}

export interface ActionMockDto {
  actionId?: number;
  actionName?: string;
  statusCode?: number;
  headers?: { name: string; value: string }[];
  body?: string;
}

export interface SandBoxTx extends HttpTransaction {
  transactionId: number;
  httpRequest: HttpRequestDefinition;
  blazeDataGenerationCompleted?: boolean;
  blazeData?: {
    blazeDataDetailLinksDto?: {
      previewFileLink?: string;
      dataFileLink?: string;
      modelFileLink?: string;
    };
    globalVariables?: { [key: string]: string };
  };
  actionMocks?: ActionMockDto[];
}

export interface MessagingMappings {
  sourceName: string;
  sourceType: MessagingSourceType;
  destinations: MessagingTransactionMapping[];
}

export interface MessagingTransactionMapping {
  destinationName: string;
  destinationType: MessagingSourceType;
}

export type MessagingSourceType = 'QUEUE' | 'TOPIC' | 'SUBSCRIPTION';

export type MessageSourceTypeList = { [key in MessagingSourceType]?: string };

export const messageSourceTypes: MessageSourceTypeList = {
  QUEUE: 'Queue',
  TOPIC: 'Topic',
  //SUBSCRIPTION: 'Subscription',
};

export interface MsgTransaction extends Transaction {
  dsl: MsgGenericDsl;
  messagingTransactionMappings?: MessagingMappings;
}

export type SampleBody = {
  [key in 'xpath' | 'json' | 'cdata_xpath']: string;
};

export interface TransactionWrapper {
  transaction: Transaction;
  serviceId: number;
}

export interface TransactionTransferObjectWrapper {
  transactions: Transaction[];
}

export interface Asset {
  id: number;
  name: string;
  created: number;
  description: string;
  createdBy: string;
  createdDate: string;
  updated: number;
  updatedBy: string;
  serviceName?: string;
  serviceId?: number;
  tags: string[];
  type?: string;
  folderId?: string;
  fileId?: string;
  data?: string;
}

export interface Certificate extends Asset {
  primaryMetadata?: PrimaryMetadata;
}

export interface Recording {
  id: number;
  serviceId: number;
  serviceName: string;
  name: string;
  description: string;
  tags: string[];
  created: number;
  updated: number;
  createdBy: string;
  updatedBy: string;
  updatedDate: string;
  createdDate: string;
  messages: RecordingMessage[];
  runtimeConfig?: {
    //Available when assigned to a service mock
    replayCount: number;
    delayBetweenReplays: number;
    initialDelay: number;
  };
}

export interface RecordingMessage {
  id: number;
  recordingId: number;
  name: string;
  messageType: MessageType;
  headers: any[];
  properties: any[];
  content: string;
  destination: string;
  destinationType: string;
  correlationId?: string;
  delay: number;
  index?: number;
  created: number;
  updated: number;
  recordedAt: number;
  createdBy: string;
  updatedBy: string;
  updatedDate: string;
  createdDate: string;
}

export interface AliasMeta {
  type: any;
  access_granted: boolean;
  password: string;
}

export interface PrimaryMetadata {
  name?: string;
  groupTag?: string | null;
  nodeList?: NodeList[];
  txnCount?: number;
  thinkTimePercent?: string;
  transportProtocol?: string;
  concurrentCapacity?: string;
  executionMode?: string;
  keystore_password?: string;
  key_password?: string;
  aliases?: { [key: string]: AliasMeta };
  keystore_access_granted?: boolean;
}

export interface Metadata {
  containerResources: ContainerResources;
}

export interface ContainerResources {
  cpuRequest: number;
  cpuLimit: number;
  memRequestMb: number;
  memLimitMb: number;
  javaMaxHeapMb: number;
}

export type buttonStyle = 'Button' | 'Text';

export type FilterFooter = {
  entity: string;
  onClick: (entityValue: string) => void;
  style: buttonStyle;
};

export type StateChangeType = 'STORE_OBJECT' | 'UPDATE_OBJECT' | 'DELETE_OBJECT' | 'UPDATE_VALUE' | 'INCREMENT_VALUE';

export interface ObjectParamsItem {
  key: string | null;
  value: string | null;
}

export interface StateChange {
  objectAction: StateChangeType;
  model: string;
  parameters: ObjectParamsItem[];
  filters: DataParamFilter[] | null;
}

interface HttpCall {
  urlMethod: string;
  urlValue: string;
  headers: PairSetItem[];
  queryParams: PairSetItem[];
  bodyContent: string;
}

export interface Webhook extends HttpCall {
  triggerTime: string;
  specific: number;
  lower: number;
  upper: number;
}

export type ActionsType = 'WEBHOOK' | 'STATE_UPDATE' | 'HTTP_CALL';

export interface ProcessingAction {
  id?: number;
  name?: string;
  actionType: ActionsType;
  definition: StateChange | Webhook | HttpCall;
  transactionId?: number;
  assets?: AssetAssignment[];
  configKeyAssets?: AssetAssignment[];
  conditions?: Condition[];
}

export type BulkOperationType = 'DELETE' | 'TAG' | 'DEPLOY' | 'START' | 'STOP' | 'CONFIGURE';

/** DTO object for bulk operation */
export type BulkOperation = {
  action: BulkOperationType;
  ids?: number[];
  specificationCriteria?: string;
  tags?: string[];
};

const DATA_OBJECT_GROUP = 'Test Data Actions';
const GLOBAL_SCOPE_GROUP = 'Global Scope Actions';

export const STORE_OBJECT: BlazeDropdownItem = { id: 'STORE_OBJECT', name: 'Store Object', group: DATA_OBJECT_GROUP };
export const UPDATE_OBJECT: BlazeDropdownItem = {
  id: 'UPDATE_OBJECT',
  name: 'Update Object',
  group: DATA_OBJECT_GROUP,
};
export const DELETE_OBJECT: BlazeDropdownItem = {
  id: 'DELETE_OBJECT',
  name: 'Delete Object',
  group: DATA_OBJECT_GROUP,
};
export const UPDATE_VALUE: BlazeDropdownItem = { id: 'UPDATE_VALUE', name: 'Update Value', group: GLOBAL_SCOPE_GROUP };
export const INCREMENT_VALUE: BlazeDropdownItem = {
  id: 'INCREMENT_VALUE',
  name: 'Increment Value',
  group: GLOBAL_SCOPE_GROUP,
};
export const stateChangeTypes: BlazeDropdownItem[] = [
  STORE_OBJECT,
  UPDATE_OBJECT,
  DELETE_OBJECT,
  UPDATE_VALUE,
  INCREMENT_VALUE,
];

export type DataParamFilter = {
  key: string | null;
  operation: FilterOperator | null;
  values: string[];
};

/** DTO representing search criteria for transaction */
export interface TransactionCriteria {
  transactionName?: string;
  tags?: string[];
  serviceId?: number;
  serviceMockId?: number;
  excludeServiceMockId?: number;
  serviceMockDraftId?: number;
  excludeServiceMockDraftId?: number;
  workspaceId?: number;
  keyword?: string;
  transactionIds?: number[];
  templateId?: number;
  excludeTemplateId?: number;
  templateDraftId?: number;
  excludeTemplateDraftId?: number;
}

export interface MsgComponent {
  id: number;
  //type: MessagingSourceType;
  name: string;
}

export interface Queue {
  name: string;
}

export interface Topic {
  name: string;
  isDurable: boolean;
  durableSubscriptionName: string | null;
}

export type EntityType = 'DATA_ENTITY' | 'DATA_PARAMETER' | 'GLOBAL_SCOPE_PARAMETER';

export type BlueprintSource = 'BUILT_IN' | 'CUSTOM';
export type BlueprintVisibility = 'PRIVATE' | 'WORKSPACE' | 'ACCOUNT';

export interface Blueprint {
  id: string;
  name: string;
  description: string;
  version: string;
  tags: string[];
  thumbnail: string; // image URL or data URL; '' renders an initials placeholder
  transactions: Transaction[];
  transactionCount?: number; // count from the list API (transactions[] is only populated on detail)
  hasBlazeData?: boolean; // true when the blueprint carries BlazeData configuration
  source: BlueprintSource;
  visibility: BlueprintVisibility; // BUILT_IN entries use ACCOUNT and render as "Built-in"
  author?: string; // display-only mock metadata
  createdAt?: number; // epoch ms
  updatedAt?: number; // epoch ms
  createdDate?: string; // pre-formatted date string from backend e.g. "June 30, 2026"
  updatedDate?: string; // pre-formatted date string from backend e.g. "June 30, 2026"
}
